import React from "react";
import { Typography } from "@mui/material";

/*
 * A validation message under a field.
 *
 * Exists because AxionControls.AxionTextBox accepts an `error` prop and then does nothing with
 * it — it destructures the value out and never passes it to the underlying TextField. Every
 * caller in this module passes one, so every one of those messages is invisible today.
 *
 * Fixing the shared control would be the better answer and is not this story's to make: it is
 * used by dozens of screens, and turning a silent prop into a rendered one changes how each of
 * them looks. Handed over as a ticket instead; this keeps the fix local to the register.
 */
export default function FieldError({ message }) {
  if (!message) return null;

  return (
    <Typography variant="caption" role="alert" sx={{ color: "error.main", display: "block", mt: 0.5 }}>
      {message}
    </Typography>
  );
}
